export const POSTCODES_FETCH_MANY_REQUEST = 'POSTCODES_FETCH_MANY_REQUEST'
export const POSTCODES_FETCH_MANY_SUCCESS = 'POSTCODES_FETCH_MANY_SUCCESS'
export const POSTCODES_FETCH_MANY_FAILURE = 'POSTCODES_FETCH_MANY_FAILURE'

export const EMPTY_POSTCODES = 'EMPTY_POSTCODES'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
